var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{scopedSlots:_vm._u([{key:"icon",fn:function(){return [_vm._v("build")]},proxy:true},{key:"title",fn:function(){return [_vm._v(_vm._s(_vm.$t('PartsLookup.Title')))]},proxy:true},{key:"body",fn:function(){return [_c('PartsLookup')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }